module.exports = __webpack_public_path__ + "img/calendar.77956a5c.svg";